/* eslint-disable */
module.exports = {

  request(req, token) {

    if(req.url=='api/token/verify/'){
      req.data.token = token;
    }

      this.options.http._setHeaders.call(this, req, {Authorization: "JWT " + token});

  },

  response(res) {
    if (res.data.token) {
      return res.data.token;
    }

  },
};



// WEBPACK FOOTER //
// ./src/driver/jwt.js